import { render, staticRenderFns } from "./evaTask.vue?vue&type=template&id=f321c856&scoped=true&"
import script from "./evaTask.vue?vue&type=script&lang=js&"
export * from "./evaTask.vue?vue&type=script&lang=js&"
import style0 from "./evaTask.vue?vue&type=style&index=0&id=f321c856&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f321c856",
  null
  
)

export default component.exports